import { Inject, Injectable } from '@angular/core';
import { WhitelabelService } from '@galaxy/partner';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { CrmDependencies, CrmInjectionToken } from '../tokens-and-interfaces';

@Injectable()
export class BrandingService {
  constructor(
    private readonly whiteLabelService: WhitelabelService,
    @Inject(CrmInjectionToken) private readonly config: CrmDependencies,
  ) {}

  getBusinessAppName(): Observable<string> {
    return this.config.namespace$.pipe(
      switchMap((namespace) => {
        return this.whiteLabelService.getBranding(namespace);
      }),
      map((branding) => branding?.apps['VBC']?.name),
      catchError((err) => {
        console.error(err);
        return of('');
      }),
    );
  }
}
